import PrintBlock from "../base/Block";
import BlockHeading from "../base/Heading";
import BlockRowContent from "../base/RowContent";

export default function BankDetailsBlock() {
    return (
        <PrintBlock
            style={{ marginVertical: "10px", fontSize: "8px", marginTop: 0 }}
        >
            <BlockHeading
                englishTitle="Bank Details"
                arabicTitle="ﺗﻔﺎﺻﻴﻞ اﻟﺒﻨﻚ"
            />

            <BlockRowContent
                englishLabel="Account Name"
                arabicLabel="اسم الحساب"
                content="Establishment Abdul Lateef Mohammed Saeed Al Refai"
                disableArabicContent
            />
            <BlockRowContent
                englishLabel="Account No"
                arabicLabel="رﻗﻢ اﻟﺤﺴﺎب"
                content="35176750000108"
                disableArabicContent
            />
            <BlockRowContent
                englishLabel="IBAN"
                arabicLabel="اﻳﺒﺎن"
                content="SA9210000035176750000108"
                disableArabicContent
            />
            <BlockRowContent
                englishLabel="Swift Code / BIC"
                arabicLabel="ﺳﻮﻳﻔﺖ ﻛﻮد / ﺑﻴﻚ"
                content="NCBKSAJE"
                disableArabicContent
            />
            <BlockRowContent
                englishLabel="Bank Name"
                arabicLabel="اﺳﻢ اﻟﺒﻨﻚ"
                content="Saudi National Bank (SNB)"
                disableArabicContent
            />
            <BlockRowContent
                englishLabel="Bank Address"
                arabicLabel="ﻋﻨﻮان اﻟﺒﻨﻚ"
                content="Yanbu"
                disableArabicContent
            />
        </PrintBlock>
    );
}
